
import {mapActions} from "vuex";

export default {
  name: "toolSoftwaresPop",
  props:['list','subpathname'],
  data() {
    return {
      jingsaiImg:require('@/assets/imgs/smproapp/jingsai.svg')
    }
  },
  methods:{
    ...mapActions(['setSmproApp']),
    goToPage(link, val, indexChild) {
      this.$parent.menuHide = true;
      if (val) {
        this.setSmproApp(indexChild-1);
      }
      if (!this.subpathname.includes(link)) {
        this.$router.push({path: link});
      }
      setTimeout(() => {
        this.$parent.menuHide = false;
      }, 100)
    }
  }
}
